import rangy from 'rangy'

const offsetFromRange = (property, calculateOffset) => (
  text,
  range,
  { snapToWords } = { snapToWords: false }
) => {
  if (range.collapsed) {
    return 0
  }

  if (snapToWords) {
    return calculateOffset(text, range[property])
  }

  return range[property]
}

export const startOffsetFromRange = offsetFromRange(
  'startOffset',
  (text, offset) => text.lastIndexOf(' ', offset) + 1
)

export const endOffsetFromRange = offsetFromRange('endOffset', (text, offset) =>
  text.indexOf(' ', Math.max(offset - 1, 0))
)

export const nodeContainsRange = (node, range) =>
  node.contains(range.startContainer) && node.contains(range.endContainer)

export const getRangeAt = idx => rangy.getSelection().getRangeAt(idx)



// WEBPACK FOOTER //
// ../src/utils/range.js